var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.5,
    height: 17.344,
    viewBox: "0 0 18.5 17.344",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11422",
    "data-name": "Group 11422",
    transform: "translate(304.5 -53) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(63.406 286)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.469,
    cy: 3.469,
    r: 3.469,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.469,
    cy: 3.469,
    r: 2.969,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    transform: "translate(63.406 297.563)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.469,
    cy: 3.469,
    r: 3.469,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.469,
    cy: 3.469,
    r: 2.969,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M1284.343,264.979l5.778-2.644",
    transform: "translate(-1225.563 27.966)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M1290.122,264.979l-5.778-2.644",
    transform: "translate(-1225.563 34.91)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(53 291.781)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.469,
    cy: 3.469,
    r: 3.469,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.469,
    cy: 3.469,
    r: 2.969,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/SendIcon.8206b3c0d8ed9c849eb7fc3623ae94e7.svg";
export { ForwardRef as ReactComponent };